import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core'
import { DataLoaderService, CommonDataService } from '../index'
import { Http } from '@angular/http';
import  * as enJson from '../../../assets/i18n/en.json';
import * as jaJson from '../../../assets/i18n/ja.json';

import { Utils } from '../../shared/utils';

@Component({
  selector: 'common-header',
  templateUrl: './common-header.template.html',
  styleUrls: ['./common-header.component.css']
})

export class HeaderComponent {
  
  private showDetails: boolean;
  private techShowDetails: boolean;
  public languageCodeArray : any
  data: any;
  enJson: any;
  serviceName :any;
  constructor(private _http: Http,private translate: TranslateService, private dataLoaderService: DataLoaderService,
    private commonDataService: CommonDataService,private http: Http) {
    this.languageCodeArray = [{"code":"br","label":"Breton"},{"code":"bg","label":"Bulgarian"},{"code":"de","label":"German"},{"code":"en","label":"English"},{"code":"fr","label":"French"},{"code":"ja","label":"Japan"},{"code":"es","label":"Spanish"},{"code":"pt","label":"Portuguese"},{"code":"it","label":"Italian"},{"code":"ru","label":"Russian"},{"code":"tr","label":"Turkish"},{"code":"el","label":"Greek"},{"code":"sr","label":"Serbian"},{"code":"sk","label":"Slovak"},{"code":"ro","label":"Romanian"},{"code":"sl","label":"Slovenian"},{"code":"hu","label":"Hungarian"},{"code":"nl","label":"Dutch"},{"code":"ar","label":"Arabic"},{"code":"hr","label":"Croatian"},{"code":"et","label":"Estonian"},{"code":"lt","label":"Lithuanian"},{"code":"sv","label":"Swedish"},{"code":"da","label":"Danish"},{"code":"pl","label":"Polish"},{"code":"cs","label":"Czech"},{"code":"fi","label":"Finnish"},{"code":"no","label":"Norwegian"},{"code":"hi","label":"Hindi"},{"code":"ko","label":"Korean"},{"code":"zh","label":"Chinese"},{"code":"zf","label":"Taiwanese"}];
    this.translate.addLangs(this.languageExtract());
    const browserLang = this.translate.getBrowserLang();
    this.translate.use(this.displayLanguage());   
    // this.checkingServices() 
  }

   checkingServices(){

    if (this.dataLoaderService.vehicleInfo.orderingMarket in {901: null, 919: null, 847: null, 817: null, 601: null, 675: null, 839: null, 701: null, 771: null, 581: null, 737: null } && (this.dataLoaderService.vehicleInfo.urlFlag === '2' || this.dataLoaderService.vehicleInfo.urlFlag === '3')){        
    this.serviceName = "CCS";
  }
}

  displayLanguage() {
    let defaultLanguage;
    this.dataLoaderService.data.availableLanguages.forEach(element => {
      if (this.dataLoaderService.vehicleInfo.language === element.language) {
        defaultLanguage = element.language;
      }
    });
    return defaultLanguage;
  }

  languageExtract() {
    let langList = [];
    this.dataLoaderService.data.availableLanguages.forEach(element => {
    if(element.name===null){
        for(let j=0; j < this.languageCodeArray.length; j++){
          if (element.language === this.languageCodeArray[j].code){
            langList.push(this.languageCodeArray[j].label);
            element.name = this.languageCodeArray[j].label;
            break;
          }
        }    
      }else{
      langList.push(element.name);
      }    
    });
    
    if(this.isMarketEG()){
      for(let i=0; i<=langList.length; i++){
        if(langList[i] === 'Arabic'){
          langList.splice(i--, 1);
        }
      }
    }

    if(this.isMarketTW()){
      for(let i=0; i<=langList.length; i++){
        if(langList[i] === 'Chinese'){
          langList.splice(i--, 1);
        }
      }
    }
    
    return langList;
  }

  ngOnInit() {
    this.showDetails = false;
    this.techShowDetails = false;
    if(this.dataLoaderService.vehicleInfo.language =='ja'){
      this.commonDataService.jsonValue = jaJson;
    }
    else{
      this.commonDataService.jsonValue = enJson; 
    }
  }
  
  changeLanguage(lang) {
    let language;

    this.dataLoaderService.data.availableLanguages.forEach(element => {
      if (element.name === lang) {
        language = element.language;
      }
    });


    this.commonDataService.notifyLanguageItem({ data: language });

    this.dataLoaderService.vehicleInfo.language = language;

    this.translate.use(language);

    this. languageExtract();
    if(this.dataLoaderService.vehicleInfo.language =='ja'){
      this.commonDataService.jsonValue = jaJson;
    }
    else{
      this.commonDataService.jsonValue = enJson; 
    }
    
    if (this.dataLoaderService.vehicleInfo.preSeriesModeFlag === 'X')
      this.dataLoaderService.getSpecialModeData();

    if (this.dataLoaderService.vehicleInfo.urlFlag === '0')
      this.dataLoaderService.getGCCDataForLang();

    if (this.dataLoaderService.vehicleInfo.urlFlag === '1')
      this.dataLoaderService.getValidationDataForLang();

    if (this.dataLoaderService.vehicleInfo.urlFlag === '2' || this.dataLoaderService.vehicleInfo.urlFlag === '3')
      this.dataLoaderService.getPPMDataForLang();
  }

  /**
  * To display the standard options dropdown
  * @param none
  * @returns none
  */
  selectStanOption(item) {
    this.showDetails = item;
    this.techShowDetails = false;
    this.dataLoaderService.flagDictionary.alternateOverlayFlag = false;
  }
  selectTechOption(item) {
    this.techShowDetails = item;
    this.showDetails = false;

  }

  isMarketEG(){
    return Utils.isCountryEG(this.dataLoaderService.vehicleInfo.orderingMarket);
  }

  isMarketTW(){
    return Utils.isCountryTW(this.dataLoaderService.vehicleInfo.orderingMarket);
  }

}


// WEBPACK FOOTER //
// ./src/app/components/common-header/common-header.component.ts